/**
 * @param {"main"|"bank"} mainOrBank
 * @returns {{country: null, use_address_type: null, address_type: {name: string, id: number}, city: null, address_1: null, address_2: null, post_code: null, state: null}}
 */
export function getDefaultAddress(mainOrBank) {
  let addressType
  if (mainOrBank === 'main') addressType = { id: 1, name: 'main' }
  else addressType = { id: 2, name: 'bank' }

  return {
    address_1: null,
    address_2: null,
    address_type: addressType,
    city: null,
    country: null,
    post_code: null,
    state: null,
    use_address_type: null
  }
}
